// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2577":"bd32c84f","4217":"9a3e37e7"}[chunkId] + ".chunk.css";
};